import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";

export function cardHolderNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (!!control.value) {
      const value = control.value.toString().split(' ')

      if (value.length !== 2) {
        return {'cardHolderNameNotValid': true};
      }

      if (value.length === 2 && !(/^[a-zA-Z- ]+$/g.test(value[0]) && /^[a-zA-Z- ]+$/g.test(value[1]))) {
        return {'cardHolderNameNotValid': true};
      }
    }

    return null;

  }
}
